'use client';

import { TextLink } from '@petsmart-ui/sparky';

import { VariantFieldset, VariantOption } from '@libs/shared-ui';

import { useSizeChart, useVariants } from './model';

import './styles.scss';

export const Variants = () => {
    const { variantGroups, handleVariantChange } = useVariants();
    const { isSizeChart, handleSizeChartClick } = useSizeChart();

    return (
        <div className="variants-container">
            {variantGroups.map(variantGroup => (
                <VariantFieldset
                    legendKey={variantGroup.name}
                    key={variantGroup.name}
                    legendValue={variantGroup.display}
                    legendAction={
                        variantGroup.name.toLocaleLowerCase() === 'size' &&
                        isSizeChart && (
                            <TextLink
                                href="#product-description"
                                data-testid="size-chart-img-url-link"
                                onClick={handleSizeChartClick}
                            >
                                Size chart
                            </TextLink>
                        )
                    }
                >
                    {variantGroup.variants.length > 1 &&
                        variantGroup.variants.map(variant => (
                            <VariantOption
                                key={variant.value}
                                value={variant.value}
                                display={variant.display}
                                variantType={variantGroup.name}
                                isChecked={variant.isChecked}
                                isUnavailable={variant.isUnavailable}
                                handleChangeAction={() =>
                                    handleVariantChange({ group: variantGroup.name, value: variant.value })
                                }
                            />
                        ))}
                </VariantFieldset>
            ))}
        </div>
    );
};
